import { render, staticRenderFns } from "./ShortcutsTableV2.vue?vue&type=template&id=e182e638&scoped=true"
import script from "./ShortcutsTableV2.vue?vue&type=script&lang=js"
export * from "./ShortcutsTableV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e182e638",
  null
  
)

export default component.exports